import React from 'react';
import { Card, Row, Col, Button, Badge } from 'react-bootstrap';
import { FaUser, FaEdit, FaIdCard, FaEnvelope, FaPhone, FaUserTag } from 'react-icons/fa';

// Targeta de resum del pagador (nom, CIF, email, telèfon); usada a OfertaDetail i ContratoDetail.
const PayerCard = ({
    pagador,
    onEdit
}) => {
    // Determine if we have enough info to show the card
    const hasData = pagador.name || pagador.vat;

    if (!hasData) return null;

    return (
        <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden">
            <Card.Header className="bg-white border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <FaUserTag className="me-2" />
                    Información del Pagador
                </div>
                {onEdit && (
                    <Button
                        variant="link"
                        className="text-white p-0"
                        onClick={onEdit}
                        title="Editar Pagador"
                        aria-label="Editar información del pagador"
                    >
                        <FaEdit size={18} />
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                <Row className="g-4">
                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaUser className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Nombre / Razón Social</label>
                                <p className="detail-card-value text-primary text-truncate" title={pagador.name}>{pagador.name || "No especificado"}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaIdCard className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">CIF / NIF</label>
                                <p className="detail-card-value">{pagador.vat || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaEnvelope className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Email de Facturación</label>
                                <p className="detail-card-value text-primary text-truncate" title={pagador.email}>{pagador.email || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaPhone className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Teléfono</label>
                                <p className="detail-card-value font-monospace">{pagador.phone || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default PayerCard;
